<template>
  <section class="report">
    <div class="report-title-wrap">
      <!--      <div v-if="$i18n.locale === 'ko'" class="agree-wrap">
        <div v-if="$t('informationCenter.consult.notice.list')" class="agree-content">
          <div class="agree-term center-agree-term">
            <html-view tag="p" :value="$t('informationCenter.consult.notice.desc')" />
            <ul>
              <template v-for="(item, key) in $t('informationCenter.consult.notice.list')">
                <html-view :key="key" tag="li" :value="item" />
              </template>
            </ul>
          </div>
        </div>
      </div>-->

      <!--<h4 class="report-title">{{ $t('informationCenter.report.head') }}</h4>-->
      <html-view :value="$t('informationCenter.report.copy')" tag="p" class="report-title-desc" />
    </div>

    <validation-observer
      ref="observer"
      v-slot="{ invalid }"
      tag="div"
    >
      <form @submit.prevent="submit">
        <div class="support-form">
          <div class="agree-wrap">
            <p class="form-title">
              {{ $t('informationCenter.report.target') }}
            </p>
            <div class="agree-content">
              <ul class="agree-term">
                <li v-for="(item, key) in $t('informationCenter.report.targetList')" :key="key">{{ item }}</li>
              </ul>
            </div>
          </div>
          <div class="agree-wrap">
            <p class="form-title">
              {{ $t('informationCenter.protection') }}
            </p>
            <div class="agree-content">
              <ul class="agree-term">
                <li v-for="(item, key) in $t('informationCenter.report.protection')" :key="key">{{ item }}</li>
              </ul>
            </div>
          </div>

          <input-form
            id="subject"
            ref="subject"
            v-model="subject"
            :title="$t('informationCenter.report.form.subject')"
            name="subject"
            :placeholder="$t('informationCenter.report.form.subjectPlaceholder')"
            type="text"
            autocomplete="off"
            required="required"
            maxlength="50"
          />

          <div class="form-row">
            <p class="form-title mb20">
              {{ $t('informationCenter.report.form.category') }}
              <small class="required">{{ $t('informationCenter.report.form.required') }}</small>
              <small class="multiple">{{ $t('informationCenter.report.form.multiple') }}</small>
            </p>
            <div class="form-control-container">
              <validation-provider
                :name="$t('informationCenter.report.form.category')"
                rules="required|exact_length:0"
              >
                <div class="form-check-block">
                  <span class="form-check">
                    <span class="form-check-input">
                      <input
                        id="category-1"
                        v-model="category"
                        type="checkbox"
                        :value="$t('informationCenter.report.form.type1')"
                      >
                      <i class="icon"><icon-check /></i>
                    </span>
                    <label for="category-1" class="form-check-text">
                      {{ $t('informationCenter.report.form.type1') }}
                      <small class="sub">{{ $t('informationCenter.report.form.type1-sub') }}</small>
                    </label>
                  </span>
                </div>
                <div class="form-check-block">
                  <span class="form-check">
                    <span class="form-check-input">
                      <input
                        id="category-2"
                        v-model="category"
                        type="checkbox"
                        :value="$t('informationCenter.report.form.type2')"
                      >
                      <i class="icon"><icon-check /></i>
                    </span>
                    <label for="category-2" class="form-check-text">
                      {{ $t('informationCenter.report.form.type2') }}
                      <small class="sub">{{ $t('informationCenter.report.form.type2-sub') }}</small>
                    </label>
                  </span>
                </div>
                <div class="form-check-block">
                  <span class="form-check">
                    <span class="form-check-input">
                      <input
                        id="category-3"
                        v-model="category"
                        type="checkbox"
                        :value="$t('informationCenter.report.form.type3')"
                      >
                      <i class="icon"><icon-check /></i>
                    </span>
                    <label for="category-3" class="form-check-text">
                      {{ $t('informationCenter.report.form.type3') }}
                      <small class="sub">{{ $t('informationCenter.report.form.type3-sub') }}</small>
                    </label>
                  </span>
                </div>
                <div class="form-check-block">
                  <span class="form-check">
                    <span class="form-check-input">
                      <input
                        id="category-4"
                        v-model="category"
                        type="checkbox"
                        :value="$t('informationCenter.report.form.type4')"
                      >
                      <i class="icon"><icon-check /></i>
                    </span>
                    <label for="category-4" class="form-check-text">
                      {{ $t('informationCenter.report.form.type4') }}
                      <small class="sub">{{ $t('informationCenter.report.form.type4-sub') }}</small>
                    </label>
                  </span>
                </div>
                <div class="form-check-block">
                  <span class="form-check">
                    <span class="form-check-input">
                      <input
                        id="category-5"
                        v-model="category"
                        type="checkbox"
                        :value="$t('informationCenter.report.form.type5')"
                      >
                      <i class="icon"><icon-check /></i>
                    </span>
                    <label for="category-5" class="form-check-text">
                      {{ $t('informationCenter.report.form.type5') }}
                    </label>
                  </span>
                </div>
              </validation-provider>
            </div>
          </div>

          <input-form
            id="name"
            ref="name"
            v-model="name"
            :title="$t('informationCenter.report.form.name')"
            name="name"
            :placeholder="$t('informationCenter.report.form.namePlaceholder')"
            type="text"
            autocomplete="off"
            required="required"
            maxlength="50"
            :disabled="anonymous"
          >
            <template v-if="locale === 'ko'" #default>
              <check-box
                id="anonymous"
                ref="anonymous"
                v-model="anonymous"
                :text="$t('informationCenter.consult.form.anonymous')"
                class="check-anonymous"
                name="anonymous"
                @input="onChangeAnonymous"
              />
            </template>
          </input-form>
          <input-form
            id="mail"
            ref="mail"
            v-model="mail"
            :title="$t('informationCenter.report.form.email')"
            name="mail"
            :placeholder="$t('informationCenter.report.form.emailPlaceholder')"
            type="email"
            autocomplete="off"
            required="required"
            maxlength="50"
          />
          <input-form
            id="tel"
            ref="tel"
            v-model="tel"
            :title="$t('informationCenter.report.form.tel')"
            name="tel"
            :placeholder="$t('informationCenter.report.form.telPlaceholder')"
            type="tel"
            autocomplete="off"
            maxlength="20"
          />
          <input-form
            id="textarea"
            ref="textarea"
            v-model="textarea"
            :title="$t('informationCenter.report.form.detail')"
            name="textarea"
            :placeholder="$t('informationCenter.report.form.detailPlaceholder')"
            type="textarea"
            autocomplete="off"
            required="required"
            maxlength="20000"
          />
          <input-form
            id="file"
            v-model="file"
            :title="$t('informationCenter.report.form.attachFile')"
            :placeholder="$t('informationCenter.report.form.attachFilePlaceholder')"
            type="file"
            :is-upload="attachFileUrl !== null"
            :loading="fileLoading"
            :error-message="fileError"
            @input="attachUpload"
            @change:delete="onDeleteFile"
          >
            <small>{{ $t('informationCenter.report.form.attachFileNote') }}</small>
          </input-form>
        </div>

        <div class="support-agree">
          <div class="agree-wrap agree-consult">
            <div class="agree-title">{{ $t('informationCenter.report.form.privateTitle') }}</div>
            <div class="agree-content">
              <html-view class="agree-term" :value="$t('informationCenter.report.form.privateValue')" />
              <div class="agree-check">
                <check-box
                  id="private"
                  ref="private"
                  v-model="agreePrivate"
                  :text="$t('informationCenter.report.form.private')"
                  name="agree-private"
                  required="required"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="support-btn">
          <button type="submit" class="btn btn-fill btn-wide" :disabled="invalid">
            {{
              $t('informationCenter.report.form.submit')
            }}
          </button>
        </div>
      </form>
    </validation-observer>
  </section>
</template>
<script>
import supportForm from '@/mixins/supportForm'
import defendPath from '@/mixins/defendPath'
import { ValidationProvider } from 'vee-validate'
import { mapGetters } from 'vuex'

export default {
  components: {
    ValidationProvider,
    iconCheck: () => import('@/static/svg/check.svg'),
  },
  mixins: [supportForm, defendPath],
  data () {
    return {
      category: []
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale/GET_LOCALE',
    })
  },
  watch: {
    agreePrivate (v) {
      this.agreeAll = v
    }
  },
  mounted () {
    this.questionType = 'COMPLIANCE'
  },
  methods: {
    submit () {
      this.textarea = `${this.textarea} \n\n / 제보유형 : ${this.category}`

      this.saveQuestion({
        title: this.subject,
        name: this.name,
        email: this.mail,
        content: this.textarea,
        phoneNumber: this.tel,
        type: ['COMPLIANCE']
      }, 'Main', {
        locale: this.$route.params.locale
      })
    },
    onChangeAnonymous (v) {
      this.name = v ? '익명' : ''
    },
  }
}
</script>
